import { Select } from 'antd';
import { chain, defaultTo, get } from 'lodash';
import React from 'react';

export function filterOption(input, option) {
  return option.label.match(new RegExp(input, 'i'));
}

export function normalizeOptions(labelField, valueField, dataSource) {
  return dataSource
    .sort((a, b) =>
      defaultTo(get(a, labelField), '').localeCompare(get(b, labelField))
    )
    .map((r) => ({
      value: get(r, valueField),
      label: get(r, labelField),
    }));
}

export function CustomSelect(props) {
  // using undocumented props: id
  const {
    onChange: originalOnChangeFn,
    dataSource,
    labelField,
    valueField,
    id: formField,
    relatedFormField,
    relatedDataField,
    form,
    ...otherProps
  } = props;

  function onChange(selected) {
    if (typeof originalOnChangeFn === 'function') {
      originalOnChangeFn(selected);
    }

    if (relatedFormField) {
      if (selected === undefined) {
        form.setFieldsValue({ [formField]: null });
      }

      const found = dataSource.find((r) => r[valueField] === selected);

      form.setFieldsValue({
        [relatedFormField]: get(found, relatedDataField, null),
      });
    }
  }

  // dirty fix for vhc_part_year
  // TODO: improve this
  let options = [];
  if (labelField === 'vhc_part_name') {
    options = chain(dataSource)
      .map((row) => ({
        label: `${row.vhc_part_name} ${row.vhc_part_year}`,
        value: row.vhc_part_id,
      }))
      .sortBy('label')
      .value();
  } else {
    options = normalizeOptions(labelField, valueField, dataSource);
  }

  return (
    <Select
      {...otherProps}
      showSearch
      filterOption={filterOption}
      options={options}
      onChange={onChange}
    />
  );
}
